import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import {
  useRecoilState,
  useRecoilValue,
} from 'recoil';
import {
  isAdmin,
  subMenuState,
} from 'state';
import styled from 'styled-components';
import Homework from 'view/pages/Communication/SubPage/Homework';
import QnA from 'view/pages/Communication/SubPage/QnA';
import Reviews from 'view/pages/Communication/SubPage/Reviews';

import {
  ContentBox,
  Contents,
} from '../../components';

interface StyledComponentProps {
    width?: string;
    display?: string;
}

export const returnColor = (text) => {
    switch (text) {
        case "New": {
            return "#FFC8DD";
        }
        case "Completed": {
            return "#9AE3B7";
        }
        case "Received": {
            return "#B0CBFF";
        }
        default:
            break;
    }
};

const Communication = () => {
    const navigate = useNavigate();
    const isAdminState = useRecoilValue(isAdmin);
    const [subMenu, setSubMenu] = useRecoilState(subMenuState);
    const [onPopup, setOnpopup] = useState(false);

    const onClickPopup = () => {
        setOnpopup((v) => !v);
    };

    console.log("onPopup", onPopup);
    const el = () => {
        switch (subMenu) {
            case "Homework": {
                return <Homework onClickPopup={onClickPopup} />;
            }
            case "Reviews": {
                return <Reviews onClickPopup={onClickPopup} />;
            }
            case "Q n As": {
                return <QnA onClickPopup={onClickPopup} />;
            }

            default:
                break;
        }
    };
    console.log("isAdminState", isAdminState);
    console.log("navigate", navigate);
    // useEffect(() => {
    //     setSubMenu("Homework");
    // }, []);
    return (
        <Container>
            {/* {onPopup && (
                <Overlay filter={true}>
                    <CoPopup onClickPopup={onClickPopup} />
                </Overlay>
            )} */}
            <ContentsWrap>
                <ContentBox>
                    <Contents title={subMenu}>{el()}</Contents>
                </ContentBox>
            </ContentsWrap>
        </Container>
    );
};
export default Communication;

const Container = styled.div``;
const ContentsWrap = styled.div`
    display: flex;
    width: 100%;
    .commonContentsHeader{
        text-transform: capitalize;
        font-family: "Europa-Bold" !important;
        font-size: 22px;
        line-height: 22px;
        font-weight: 700;
    }
`;
const Wrap = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    flex: 1;
    position: relative;
`;
